module.exports = __webpack_public_path__ + "img/icon_cowheat_color.7267ece1.svg";